module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('span', {
    attrs: {
      "id": "qContents4"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapter-name"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/preface1938"
    }
  }, [_c('span', [_vm._v("Preface to the 1938 Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/foreword1997"
    }
  }, [_c('span', [_vm._v("Foreword to the 1997 Edition by Wilebaldo Solano")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/transintro"
    }
  }, [_c('span', [_vm._v("Translator’s Introduction by Peter Sedgwick")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/transackn"
    }
  }, [_c('span', [_vm._v("Translator’s Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/preface1930"
    }
  }, [_c('span', [_vm._v("Preface to the 1930 Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter1"
    }
  }, [_c('span', [_vm._v("1 From Serfdom to Proletarian Revolution")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("2 The Insurrection of 25 October 1917")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("3 The Urban Middle Classes against the Proletariat")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("4 The First Flames of the Civil War: The Constituent Assembly")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("5 Brest-Litovsk")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("6 The Truce and the Great Retrenchment")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("7 The Famine and the Czechoslovak Intervention")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("8 The July-August Crisis")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("9 The Terror and the Will to Victory")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("10 The German Revolution")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("11 War Communism")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/postface",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Postface: Thirty Years After the Russian Revolution")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/postscript",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Postscript: The Allied Part in the Czechoslovak Intervention")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/postscriptnotes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Notes 497 Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/more",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("More by Victor Serge Available in English")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb74dd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 60
// module chunks = 0